enum ROUTES {
  ADMINISTRATION = '/administration',
  USER_ROLES = '/administration/roles',
  ROLE_ADD = '/administration/roles/add',
  ROLE_EDIT = '/administration/roles/:roleId/edit',

  USER_LIST = '/administration/users',
  USER_ADD = '/administration/users/add',
  USER_EDIT = '/administration/users/:userId/edit',
  SETTINGS_PROFILE = '/administration/profile',
  CHANGE_LOGS = '/administration/change-logs',
  NOTIFICATION_SETTINGS = '/administration/notification-settings',

  SETTINGS = '/settings',
  OTHER_SETTINGS = '/settings/other-settings',
  CARDS = '/settings/other-settings/cards',
  TOP_UP = '/settings/other-settings/top-up',
  STATEMENT = '/settings/other-settings/statement',
  APPLICATIONS = '/settings/applications',
  APPLICATIONS_LIST = '/settings/applications/list',
  APPLICATION_ITEM = '/settings/scheme/:schemeId',

  TRANSACTION_SETTINGS = '/settings/transaction-settings',
  TRANSACTION_SETTINGS_TR_TYPES = '/settings/transaction-settings/transaction-types',
  TRANSACTION_SETTINGS_PAYMENT_TYPES = '/settings/transaction-settings/payment-types',
  TRANSACTION_SETTINGS_BENEFICIARIES = '/settings/transaction-settings/beneficiaries',
  TRANSACTION_SETTINGS_OPTIONS = '/settings/transaction-settings/options',
  TRANSACTION_SETTINGS_EXCHANGE = '/settings/transaction-settings/exchange',
  TRANSACTION_SETTINGS_CASP = '/settings/transaction-settings/casp',
  TRANSACTION_SETTINGS_OVERDRAFT = '/settings/transaction-settings/overdraft',
  TRANSACTION_SETTINGS_PROCESSING_RULES = '/settings/transaction-settings/processing-rules',
  TRANSACTION_SETTINGS_PROCESSING_RULES_LIST = '/settings/transaction-settings/processing-rules/list',
  TRANSACTION_SETTINGS_PROCESSING_RULES_CREATE = '/settings/transaction-settings/processing-rules/list/create',
  TRANSACTION_SETTINGS_PROCESSING_RULES_EDIT = '/settings/transaction-settings/processing-rules/list/:ruleId',
  TRANSACTION_SETTINGS_IBAN = '/settings/transaction-settings/iban',
  TRANSACTION_SETTINGS_PURPOSE_CODE = '/settings/transaction-settings/purpose-code',

  AGREEMENTS_LIST = '/settings/agreements',
  AGREEMENTS_ADD = '/settings/agreements/add',
  AGREEMENTS_READ = '/settings/agreements/:agreementId',

  REPORTS_SETTINGS = '/settings/reports',
  REPORTS_SETTINGS_FINTRAC = '/settings/reports/fintrac',

  CURRENCIES = '/settings/currencies',
  CURRENCIES_ITEM = '/settings/currencies/:currencyId',
  COUNTRIES = '/settings/countries',
  COUNTRY = '/settings/countries/:id',
  PSP = '/settings/psp',
  PSP_DETAILS = '/settings/psp/details',
  PSP_RATES = '/settings/psp/rates',
  PSP_WEBHOOKS = '/settings/psp/webhooks',
  PSP_AUTHORIZATION = '/settings/psp/authorization',
  PSP_BRAND = '/settings/psp/brand',
  PSP_LANGUAGES = '/settings/psp/languages',
  PSP_OTP = '/settings/psp/otp',
  DICTIONARIES = '/settings/dictionaries',
  DICTIONARIES_LIST = '/settings/dictionaries/list',
  DICTIONARIES_LIST_ITEMS = '/settings/dictionaries/:dictionaryId/items',
  DICTIONARIES_LIST_ITEMS_EDIT = '/settings/dictionaries/:dictionaryId/items/:itemId/edit',
  DICTIONARIES_LIST_ITEMS_CREATE = '/settings/dictionaries/:dictionaryId/items/create',

  CLIENTS_LIST = '/administration/clients',
  CLIENTS_EDIT = '/administration/clients/:clientId',

  SECURITY = '/administration/security',
  SECURITY_LOCKS = '/administration/security/locks',
  SECURITY_LOCKS_CREATE = '/administration/security/locks/create',
  SECURITY_LOCKS_ITEM = '/administration/security/locks/:lockId',
  SECURITY_LOGS = '/administration/security/logs',
  SECURITY_LOGS_CREATE = '/administration/security/logs/create',
  SECURITY_LOGS_ITEM = '/administration/security/logs/:logId',

  ANONYMISATION = '/administration/anonymisation',
}

export default ROUTES;
